import { Button } from "../button";

export const Card = (props) => {
  const { title, desc, buttonLabel, onPress } = props || {};

  return (
    <div className="p-6 rounded-xl bg-white border border-solid border-gray-200 md:m-0 m-6 md:mt-8 flex flex-col items-center">
      <span className="text-xl font-semibold text-gray-900">{title}</span>
      <div className="my-2" />
      <span className="text-base font-medium text-gray-700 md:text-center">
        {desc}
      </span>
      <div className="my-4" />
      <Button label={buttonLabel} width={"w-36 md:w-44"} onClick={onPress} />
    </div>
  );
};
